(function() { window.GUID_140e0d5e_00ad_40c6_90b7_6c446636d898 = { getGuid: function() { return "140e0d5e-00ad-40c6-90b7-6c446636d898"; } }; })();
var CS;
(function (CS) {
    let Highlighted;
    (function (Highlighted) {
        Highlighted[Highlighted["PersonaWall"] = 0] = "PersonaWall";
        Highlighted[Highlighted["StatsWall"] = 1] = "StatsWall";
        Highlighted[Highlighted["EventWall"] = 2] = "EventWall";
        Highlighted[Highlighted["DivisionWall"] = 3] = "DivisionWall";
        Highlighted[Highlighted["MatchesWall"] = 4] = "MatchesWall";
        Highlighted[Highlighted["OpponentsWall"] = 5] = "OpponentsWall";
        Highlighted[Highlighted["Events"] = 6] = "Events";
        Highlighted[Highlighted["Leagues"] = 7] = "Leagues";
        Highlighted[Highlighted["LeaguesAndTournaments"] = 8] = "LeaguesAndTournaments";
        Highlighted[Highlighted["Tournaments"] = 9] = "Tournaments";
        Highlighted[Highlighted["MyEventsUnidentified"] = 10] = "MyEventsUnidentified";
        Highlighted[Highlighted["MyEventsLinked"] = 11] = "MyEventsLinked";
        Highlighted[Highlighted["MyEventsNotLinked"] = 12] = "MyEventsNotLinked";
        Highlighted[Highlighted["MyPins"] = 13] = "MyPins";
        Highlighted[Highlighted["MyMessages"] = 14] = "MyMessages";
        Highlighted[Highlighted["Schedules"] = 15] = "Schedules";
        Highlighted[Highlighted["Stats"] = 16] = "Stats";
        Highlighted[Highlighted["Brackets"] = 17] = "Brackets";
        Highlighted[Highlighted["MyMessagesAll"] = 18] = "MyMessagesAll";
        Highlighted[Highlighted["MyMessagesRead"] = 19] = "MyMessagesRead";
        Highlighted[Highlighted["MyMessagesUnread"] = 20] = "MyMessagesUnread";
        Highlighted[Highlighted["SettingsFollowers"] = 21] = "SettingsFollowers";
        Highlighted[Highlighted["SettingsBlockedUsers"] = 22] = "SettingsBlockedUsers";
        Highlighted[Highlighted["SettingsFollowedPlayers"] = 23] = "SettingsFollowedPlayers";
        Highlighted[Highlighted["SettingsLastSearches"] = 24] = "SettingsLastSearches";
        Highlighted[Highlighted["SettingsFavorites"] = 25] = "SettingsFavorites";
        Highlighted[Highlighted["SchedulesList"] = 26] = "SchedulesList";
        Highlighted[Highlighted["SchedulesTable"] = 27] = "SchedulesTable";
        Highlighted[Highlighted["StatGraph"] = 28] = "StatGraph";
        Highlighted[Highlighted["Summary"] = 29] = "Summary";
        Highlighted[Highlighted["MatchHistory"] = 30] = "MatchHistory";
        Highlighted[Highlighted["StatGrids"] = 31] = "StatGrids";
        Highlighted[Highlighted["WeeklyStatGrids"] = 32] = "WeeklyStatGrids";
        Highlighted[Highlighted["Compare"] = 33] = "Compare";
        Highlighted[Highlighted["BestImprovements"] = 34] = "BestImprovements";
        Highlighted[Highlighted["MainMenu"] = 35] = "MainMenu";
        Highlighted[Highlighted["Settings"] = 36] = "Settings";
        Highlighted[Highlighted["Leaderboard"] = 37] = "Leaderboard";
        Highlighted[Highlighted["Home"] = 38] = "Home";
        Highlighted[Highlighted["MainSearch"] = 39] = "MainSearch";
    })(Highlighted = CS.Highlighted || (CS.Highlighted = {}));
})(CS || (CS = {}));

//# sourceMappingURL=Highlighted.pre.js.map
